export default __webpack_public_path__ + "static/media/postgres.a7d638cb.svg";